import * as React from 'react';
import { memo } from 'react';

const SvgCrown = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 7 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.607 4.875a.193.193 0 0 0 .239.14 6.511 6.511 0 0 1 3.475 0 .193.193 0 0 0 .238-.14l.609-2.584a.19.19 0 0 0-.263-.219l-1.207.537a.193.193 0 0 1-.245-.081L3.75 1.263a.19.19 0 0 0-.333 0l-.702 1.265a.193.193 0 0 1-.245.08l-1.207-.536a.19.19 0 0 0-.263.22l.606 2.583Z", stroke: "currentColor", strokeWidth: 0.6, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgCrown);

export { Memo as default };
